import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { get } from 'lodash';
import { cn } from '@src/utils/ui';

export const TextAreaInput = ({ name, InputProps = {}, disabledVertivalResize, ...rest }) => {
    const { control, formState } = useFormContext();
    const error = !!get(formState.errors, name);
    const helperText = get(formState.errors, `${name}.message`);

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <TextField
                    {...field}
                    {...rest}
                    value={field.value || ''}
                    multiline
                    error={error}
                    helperText={helperText}
                    InputProps={{
                        ...InputProps,
                        className: cn('tw-text-[16px]', InputProps.className)
                    }}
                    SelectProps={{ className: 'tw-text-[16px]' }}
                    InputLabelProps={{ className: 'tw-text-[16px]' }}
                    FormHelperTextProps={{ className: 'tw-text-[12px]' }}
                    sx={
                        disabledVertivalResize
                            ? null
                            : {
                                  '& .MuiInputBase-inputMultiline': {
                                      resize: 'vertical' // allow vertical resizing
                                  }
                              }
                    }
                />
            )}
        />
    );
};

// -------- PropTypes -------- //

TextAreaInput.propTypes = {
    name: PropTypes.string.isRequired,
    InputProps: PropTypes.object,
    disabledVertivalResize: PropTypes.bool
};
